import { MapPin, Phone } from "lucide-react";
import { motion } from "framer-motion";
import { Reveal, RevealStagger, staggerItem } from "@/components/Reveal";
import { serviceAreas, business, images } from "@/data/content";

export default function ServiceArea() {
  return (
    <section id="area" className="py-14 lg:py-20 bg-pristine-surface" data-testid="area-section">
      <div className="mx-auto max-w-7xl px-5 grid lg:grid-cols-2 gap-14 items-center">
        <div>
          <Reveal>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-pristine-aquadeep mb-4">Service Area</p>
            <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-medium text-pristine-navy tracking-tight text-balance">
              Local Water System Specialists
            </h2>
          </Reveal>

          <RevealStagger className="mt-9 flex flex-wrap gap-2.5">
            {serviceAreas.map((a) => (
              <motion.span
                key={a}
                variants={staggerItem}
                className="inline-flex items-center gap-1.5 rounded-full bg-white border border-pristine-aqua px-4 py-2 text-sm font-medium text-pristine-navy"
              >
                <MapPin className="h-3.5 w-3.5 text-pristine-aquadeep" />
                {a}
              </motion.span>
            ))}
          </RevealStagger>

          <Reveal delay={0.15}>
            <div className="mt-9 rounded-2xl bg-white border border-pristine-aqua p-6 flex items-center gap-4">
              <span className="inline-flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-pristine-aqua">
                <Phone className="h-5 w-5 text-pristine-blue" />
              </span>
              <div>
                <p className="text-sm text-pristine-navy/70">Not sure whether we service your area?</p>
                <a href={business.phoneHref} className="font-heading text-lg font-semibold text-pristine-blue hover:text-pristine-aquadeep">
                  Call {business.phone}
                </a>
              </div>
            </div>
          </Reveal>
        </div>

        <Reveal delay={0.1}>
          <div className="relative rounded-[2rem] overflow-hidden shadow-[0_24px_60px_rgba(15,58,112,0.14)] aspect-[4/3]">
            <img
              src={images.coastline}
              alt="Aerial view of the Sunshine Coast coastline and hinterland in Queensland"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-pristine-navy/40 to-transparent" />
            <div className="absolute bottom-5 left-5 bg-white/90 backdrop-blur-md rounded-xl px-4 py-3">
              <p className="font-heading text-sm font-semibold text-pristine-blue">Servicing the Sunshine Coast</p>
              <p className="text-xs text-pristine-navy/60">Noosa · Maroochydore · Hinterland</p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
